export default __webpack_public_path__ + "static/media/iom-izkuturik-00.9b46e2ec.jpg";